exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1_lB{display:block;position:relative;float:left;width:100%}", ""]);

// exports
exports.locals = {
	"root": "_1_lB",
	"root": "_1_lB"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"camelCase":true,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:4]","minimize":true}!../~/postcss-loader?pack=default!./components/ContactSidebar/ContactSidebar.css
// module id = 234
// module chunks = 0